import {types} from './types';

export const setGetListLanguageAction = (payload) => {
    return {
        type: types.SET_GET_LIST_LANGUAGE,
        payload,
      }
}

export const setGetListDictionaryAction = (payload) => {
  return {
    type: types.SET_GET_LIST_DICTIONARY,
    payload
  }
}